import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { batchedSubscribe } from 'redux-batched-subscribe';
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import createSagaMiddleware, { END } from 'redux-saga';
import persistState from 'redux-localstorage';
import {
    notificationMiddleware,
    loadingBarMiddleware /*, createAuthErrorMiddleware*/
} from '@adrias-online/steiner';
import Immutable from 'seamless-immutable';

import reducer from '../reducers';
import unauthorizedMiddleware from './middleware/unauthorizedMiddleware';

const sagaMiddleware = createSagaMiddleware();

const enhancer = compose(
    applyMiddleware(
        thunkMiddleware,
        sagaMiddleware,
        unauthorizedMiddleware,
        // createAuthErrorMiddleware(),
        notificationMiddleware,
        loadingBarMiddleware
    ),
    persistState(['user', 'currentHotel', 'currentPortale', 'sidebarStatus'], {
        key: window.__RUNTIME_CONFIG__.REACT_APP_NAME,
        deserialize: data => {
            return Immutable(JSON.parse(data));
        }
    }),
    batchedSubscribe(batchedUpdates)
);

export default function configureStore(preloadedState = {}) {
    const store = createStore(reducer, preloadedState, enhancer);

    store.runSaga = sagaMiddleware.run;
    store.close = () => store.dispatch(END);

    return store;
}
